import InnerPageHeading from "./InnerPageHeading";

function Whyus(){
    return(
        <>
            <InnerPageHeading title="Why Us"/>
            <section className="gfe-sec">
                <div className="container">
                    <div className="cooming-soon">
                        Page Comming Soon...
                    </div>
                </div>
           </section>
        </>
    );
}

export default Whyus;